<script>
  import active from 'svelte-spa-router/active';
  import { link, location } from 'svelte-spa-router';
  import Router from 'svelte-spa-router';
  import { onMount, afterUpdate, onDestroy } from 'svelte';

  import Sidebar from './components/sidebar.svelte';
  import SidebarLateral from './components/sidebarlateral.svelte';
  import Footer from './components/footer.svelte';
  import Capa from './components/capa.svelte';
  import Header from './components/header.svelte';
  import Container from './components/layout/container.svelte';
  import routes from './routes';
  import navegacaoStore from './store';
  import conteudo from './conteudo';
  import MenuTools from './components/recursos/menu_tools.svelte';

  let root;
  let selected;
  let sel_pri;
  let sel_ter;

  let paginaAtual = '';

  let dados = {
    ...conteudo,
  };

  navegacaoStore.set(dados);
  navegacaoStore.subscribe((dadosStore) => {
    dados = dadosStore;
  });

  const getCorModulo = () => {
    return selected;
  };

  const inicializacao = (callback) => {
    selected = getCorModulo();
    selecaoModulo();
    AOS.init();
    j$('html').animate({ scrollTop: 0 }, 500);
    check_all_images_complete(() => {
      /**
       * Inicializar funções necessárias aqui
       */
      // refresh_objects_listeners();
      AOS.refreshHard();
    });
  };

  onMount(() => {
    inicializacao();
  });

  afterUpdate(() => {
    if ($location !== paginaAtual) {
      inicializacao();
    }
    AOS.refreshHard();
    paginaAtual = $location;
  });

  const selecaoModulo = () => {
    sel_pri = 'C1';
    root.style.setProperty('--COR_MOD_PRI', `var(--${sel_pri}_PRI)`);
    root.style.setProperty('--COR_MOD_PRI_70', `var(--${sel_pri}_PRI_70)`);
    root.style.setProperty('--COR_MOD_PRI_20', `var(--${sel_pri}_PRI_20)`);
    root.style.setProperty('--COR_MOD_PRI_DES_1', `var(--${sel_pri}_PRI_DES_1)`);
    root.style.setProperty('--COR_MOD_PRI_DES_2', `var(--${sel_pri}_PRI_DES_2)`);
    root.style.setProperty('--COR_MOD_PRI_BOAS_1', `var(--${sel_pri}_PRI_BOAS_1)`);
    root.style.setProperty('--COR_MOD_PRI_BOAS_2', `var(--${sel_pri}_PRI_BOAS_2)`);
    root.style.setProperty('--COR_MOD_PRI_FIX_1', `var(--${sel_pri}_PRI_FIX_1)`);
    root.style.setProperty('--COR_MOD_PRI_FIX_2', `var(--${sel_pri}_PRI_FIX_2)`);
    root.style.setProperty('--COR_MOD_PRI_TABS_1', `var(--${sel_pri}_PRI_TABS_1)`);
    root.style.setProperty('--COR_MOD_SEC', `var(--${sel_pri}_SEC)`);
    root.style.setProperty('--COR_MOD_TER', `var(--${sel_pri}_TER)`);
    root.style.setProperty('--COR_MOD_TER_POD_1', `var(--${sel_pri}_TER_POD_1)`);
    root.style.setProperty('--COR_MOD_TER_POD_2', `var(--${sel_pri}_TER_POD_2)`);
    root.style.setProperty('--COR_MOD_QUA', `var(--${sel_pri}_QUA)`);
    root.style.setProperty('--COR_MOD_QUI', `var(--${sel_pri}_QUI)`);
  };
</script>

<svelte:head>
  <title>SENAD</title>
</svelte:head>

<main bind:this={root}>
  <!-- <MenuTools /> -->
  <SidebarLateral />
  <!-- <Sidebar /> -->

  <div class="tbb">
    <p>Dev Mode</p>
    <div class="bmr">
      <div class="toggle">
        <input type="checkbox" class="check" checked />
        <b class="b switch"></b>
        <b class="b track"></b>
      </div>
    </div>
  </div>

  <div class="page-content">
    <Header force={true} />
    <Router {routes} />
  </div>

  <!-- Remover em produção -->
  <div class="previa-modulo dev-mode">
    <select
      class="color-picker"
      name="previa"
      id="previa"
      bind:value={selected}
      on:click={selecaoModulo}
    >
      <option value="B">Curso 1</option>
      <option value="C">Curso 2</option>
      <option value="D">Curso 3</option>
    </select>
  </div>

  <Footer />
</main>

<style>
  .page-content {
    /* width: 100%; */
    /* overflow: hidden; */
  }
  .page-content {
    /* overflow-x: scroll; */
    /* width: 2100px; */
    /* width: max-content; */
  }
  /* ----- toggle dev mode ----- */
  .color-picker {
    font-weight: 900;
    color: #fff;
  }

  .tbb {
    position: fixed;
    top: 6px;
    right: 5px;
    z-index: 10103;
    display: grid;
    grid-template-columns: 60px 45px;
    color: #ccc;
    background: linear-gradient(#555, #111);
    padding: 3px 0px 3px 10px;
    border-radius: 20px;
    font-size: 12px;
    opacity: 1;
    display: none;
  }

  .tbb p {
    padding: 1px 0 0 0;
    font-size: 12px;
    margin: 0;
  }

  .tbb .bmr {
    position: relative;
  }

  .b {
    display: block;
  }

  .toggle {
    transform: scale(0.45);
    position: absolute;
    top: 50%;
    left: 50%;
    width: 60px;
    height: 40px;
    border-radius: 100px;
    background-color: #ddd;
    margin: -20px -30px;
    overflow: hidden;
    box-shadow: inset 0 0 2px 1px rgba(0, 0, 0, 0.05);
  }

  .check {
    position: absolute;
    display: block;
    cursor: pointer;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
    z-index: 6;
  }

  .check:checked ~ .track {
    box-shadow: inset 0 0 0 20px #4bd863;
  }

  .check:checked ~ .switch {
    right: 2px;
    left: 22px;
    transition: 0.35s cubic-bezier(0.785, 0.135, 0.15, 0.86);
    transition-property: left, right;
    transition-delay: 0.05s, 0s;
  }

  .switch {
    position: absolute;
    left: 2px;
    top: 2px;
    bottom: 2px;
    right: 22px;
    background-color: #fff;
    border-radius: 36px;
    z-index: 1;
    transition: 0.35s cubic-bezier(0.785, 0.135, 0.15, 0.86);
    transition-property: left, right;
    transition-delay: 0s, 0.05s;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
  }

  .track {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    transition: 0.35s cubic-bezier(0.785, 0.135, 0.15, 0.86);
    box-shadow: inset 0 0 0 2px rgba(0, 0, 0, 0.05);
    border-radius: 40px;
  }

  .previa-modulo {
    position: fixed;
    top: 10px;
    right: 130px;
    z-index: 100000;
    font-family: monospace;
    color: black;
    font-size: 14px;
    padding: 0 0 0 80px;
    display: none;
    background: linear-gradient(
      to right,
      var(--COR_MOD_PRI) 0%,
      var(--COR_MOD_TER) 50%,
      white 50%,
      white 100%
    );
  }

  .previa-modulo select {
    position: relative;
    font-size: 14px;
    font-family: monospace;
    outline: none;
    /* border: none; */
    color: black;
    border-radius: 3px 3px 0 0;
    top: -1px;
    border: none;
    outline: none;
  }

  .previa-modulo select option {
    font-family: monospace;
    border: none;
    outline: none;
  }

  @media (min-width: 1440px) {
  }

  @media (max-width: 1245px) {
  }

  @media (max-width: 767px) {
  }
</style>
